var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapitalRatio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 91.7 50.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#f7f7f7",
    d: "M9.344 33.013H6.199c-2.161 0-4.028-1.769-4.028-4.029V20.24c0-2.161 1.768-4.028 4.028-4.028h3.145v16.802z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#f7f7f7",
    d: "M17.99 40.775h-3.832a4.822 4.822 0 0 1-4.814-4.815V14.246a4.822 4.822 0 0 1 4.814-4.815h3.734c.098 6.289.098 24.662.098 31.344z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#f7f7f7",
    d: "M22.706 49.225h-.982a3.732 3.732 0 0 1-3.734-3.734V5.305a3.732 3.732 0 0 1 3.734-3.734h.982a3.732 3.732 0 0 1 3.734 3.734V45.49a3.732 3.732 0 0 1-3.734 3.734z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#f7f7f7",
    d: "M26.44 19.945h39.597v8.646H26.44zM83.133 33.013h3.144c2.162 0 4.029-1.769 4.029-4.029V20.24c0-2.161-1.769-4.028-4.029-4.028h-3.144v16.802z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#f7f7f7",
    d: "M74.585 40.775h3.832a4.822 4.822 0 0 0 4.814-4.815V14.246a4.822 4.822 0 0 0-4.814-4.815h-3.734c-.098 6.289-.098 24.662-.098 31.344zM69.77 49.225h.983a3.732 3.732 0 0 0 3.734-3.734V5.305a3.732 3.732 0 0 0-3.734-3.734h-.983a3.732 3.732 0 0 0-3.733 3.734V45.49a3.732 3.732 0 0 0 3.733 3.734z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalRatio);
export default __webpack_public_path__ + "static/media/capitalRatio.a3b7e25ebe8e4035bb420ddf9852e742.svg";
export { ForwardRef as ReactComponent };